<script setup lang="ts">
import VideoPoster from '~/assets/video-poster.jpg'
</script>

<template>
  <section class="border-y py-12 px-4 border-gray-300 text-center">
    <div class="relative max-w-full text-center w-[720px] aspect-video mx-auto overflow-hidden">
      <iframe
        src="https://www.youtube.com/embed/XJfWZBLS1ik"
        :title="$t('project.name')"
        class="w-full h-full"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        loading="lazy"
        :poster="VideoPoster"
      />
    </div>
  </section>
</template>
